import { useContext } from "react";
import { WebformContext } from "../contexts";

const useWebform = () => {
  return useContext(WebformContext);
};

export default useWebform;
